import React from 'react';
import { useFitToWidth } from '../hooks/useFitToWidth';

export interface FitTableProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Draw the card shell (border + radius) on the wrapper — use for `.bga-table`. */
  card?: boolean;
  /** Text floor in px (default 10). */
  minFontPx?: number;
}

/**
 * Scroll wrapper for a data table that first tries to FIT the available
 * width — shrinking the table's text and padding via `--fit-scale` down to a
 * 10px floor — and only scrolls sideways when it still can't fit.
 *
 * Usage: `<FitTable><table className="tbl tbl--sm">…</table></FitTable>`.
 * The table's CSS must derive every size from `em` / `--fit-scale`
 * (see src/css/tables.css). `className` is passed through so page-specific
 * wrapper rules (e.g. a media-query swap) keep working.
 */
const FitTable: React.FC<FitTableProps> = ({ card, minFontPx, className, children, ...rest }) => {
  const ref = useFitToWidth<HTMLDivElement>({ minFontPx });
  const cls = ['fit-scroll', card ? 'fit-scroll--card' : '', className || ''].filter(Boolean).join(' ');
  return (
    <div ref={ref} className={cls} {...rest}>
      {children}
    </div>
  );
};

export default FitTable;
